export const MONITORING_ENABLED_TENANT_ID =
  "d998be9e-7dbc-4814-baa6-25d5de2c47f9";

export const isMonitoringTabEnabled = (accountId?: string | null) =>
  accountId === MONITORING_ENABLED_TENANT_ID;
